import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { useEffect, type Dispatch, type SetStateAction } from "react";
import { useExplorations } from "../../hooks/explorations/useExplorations";
import { EnrollStudentsForm } from "../../forms/explorations/EnrollStudentsForm";

const EnrollStudentsSheet = ({
  open,
  onOpenChange,
  exploration,
  students,
  setStudents,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exploration: any;
  students: any[];
  setStudents: Dispatch<SetStateAction<any[]>>;
}) => {
  const { loadStudents } = useExplorations();

  useEffect(() => {
    if (!students.length) {
      loadStudents(setStudents);
    }
  }, [students]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>Enroll Students in {exploration.name}</SheetTitle>
          <SheetDescription>
            Maually enroll students into {exploration.name}.
          </SheetDescription>
        </SheetHeader>
        <EnrollStudentsForm
          exploration={exploration}
          students={students}
          onSuccess={() => {}}
        />
      </SheetContent>
    </Sheet>
  );
};

export { EnrollStudentsSheet };
